import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
export function useRefreshClientReferenceFields() {
    const queryClient = useQueryClient();
    return useCallback(()=>{
        void queryClient.invalidateQueries({
            queryKey: [
                QueryKeys.ClientReferenceFieldNames
            ]
        }, {
            cancelRefetch: false
        });
        void queryClient.invalidateQueries({
            queryKey: [
                QueryKeys.ClientReferenceFieldValues
            ]
        }, {
            cancelRefetch: false
        });
    }, [
        queryClient
    ]);
}
